// extracted by mini-css-extract-plugin
export default {"loadmore":"LoadMore_loadmore__FxmFQ","spinner":"LoadMore_spinner__ckjGJ","text":"LoadMore_text__fC956"};